import axios from "axios";
import Swal from "sweetalert2";

export const getWithdrawals = async (page, filters) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/withdrawals",
        {
          params: {
            page,
            ...filters
          },
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const showWithdrawal = async (id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        `/v1/admin/withdrawals/${id}`,
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const postWithdrawal = async (postData) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/withdrawals", postData,
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const updateWithdrawal = async (postData, id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/withdrawals/${id}`, postData,
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const deleteWithdrawal = async (id, lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/withdrawals/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          AcceptLanguage: lang,
        }
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};